import Styles from './InstagramStoryPreview.module.scss'
import { Heart } from 'blaze-ui/icons/24'
import { Send1 } from 'blaze-ui/icons'
import { InstagramIntegration } from 'api/clients/ExternalIntegrationsClient'
import cx from 'classnames'
import { ReactNode } from 'react'
import { MediaObject } from 'types'
import { MediaRenderer } from '../components/MediaRenderer/MediaRenderer'
import { DesignChannel } from 'components/NewFileModal/Types'
import { Header } from './Header'

interface InstagramStoryPreviewProps {
  integration?: InstagramIntegration
  mediaObject?: MediaObject
  showVideoControls?: boolean
  onEdit?: () => void
  containerClassName?: string
  customPreviewContent?: ReactNode
  isActive?: boolean
  isTransitioning?: boolean
  isGenerating?: boolean
  showHoverActionOverlay?: boolean
  almanacFileKey?: string
  onClose?: () => void
}

export const InstagramStoryPreview = ({
  integration,
  showVideoControls,
  onEdit,
  containerClassName,
  customPreviewContent,
  mediaObject,
  isActive = true,
  isTransitioning = false,
  isGenerating = false,
  showHoverActionOverlay = false,
  almanacFileKey,
  onClose,
}: InstagramStoryPreviewProps) => {
  return (
    <div className={cx(Styles.container, containerClassName)}>
      <Header integration={integration} onEdit={onEdit} />

      <div className={Styles.content}>
        {customPreviewContent && customPreviewContent}
        {!customPreviewContent && mediaObject && (
          <MediaRenderer
            channel={DesignChannel.InstagramStory}
            mediaObject={mediaObject}
            alt="Story content"
            className={Styles.storyImage}
            showHoverActionOverlay={showHoverActionOverlay}
            almanacFileKey={almanacFileKey}
            showVideoControls={showVideoControls}
            isActive={isActive}
            onClose={onClose}
            isGenerating={isGenerating}
          />
        )}
      </div>

      <div className={Styles.footer}>
        <div className={Styles.messageInput}>
          <input type="text" placeholder="Send message..." readOnly />
        </div>
        <div className={Styles.actions}>
          <Heart />
          <Send1 />
        </div>
      </div>
    </div>
  )
}
